import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import * as i0 from '@angular/core';
import { Pipe, inject, EventEmitter, Component, ChangeDetectionStrategy, Input, Output } from '@angular/core';
import * as i1 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { WA_WINDOW } from '@ng-web-apis/common';
import { tuiIsElement, TuiAutoFocus } from '@taiga-ui/cdk';
import { TuiButton, TuiLink, TuiScrollbar } from '@taiga-ui/core';
import { TUI_EDITOR_LINK_OSI_PROTOCOL_DIVIDER, TUI_EDITOR_LINK_HASH_PREFIX, TUI_EDITOR_LINK_SIMPLE_PROTOCOL_DIVIDER, TUI_EDITOR_OPTIONS, TUI_EDITOR_LINK_TEXTS, TUI_EDITOR_LINK_HTTPS_PREFIX } from '@taiga-ui/editor/common';
import { TuiTiptapEditorService } from '@taiga-ui/editor/directives';
import { TuiInputInline } from '@taiga-ui/kit';
function TuiEditLink_ng_container_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, "Edit anchor");
    i0.ɵɵelementContainerEnd();
  }
}
function TuiEditLink_ng_container_1_ng_template_4_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Link to anchor");
    i0.ɵɵelementEnd();
  }
}
function TuiEditLink_ng_container_1_ng_template_4_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "URL");
    i0.ɵɵelementEnd();
  }
}
function TuiEditLink_ng_container_1_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TuiEditLink_ng_container_1_ng_template_4_span_0_Template, 2, 0, "span", 4)(1, TuiEditLink_ng_container_1_ng_template_4_ng_template_1_Template, 2, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const urlTitle_r2 = i0.ɵɵreference(2);
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r2.prefixIsHashMode)("ngIfElse", urlTitle_r2);
  }
}
function TuiEditLink_ng_container_1_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const text_r4 = ctx.ngIf;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.prefixIsHashMode ? text_r4.anchorExample : text_r4.urlExample, " ");
  }
}
function TuiEditLink_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "label", 6)(2, "div", 7);
    i0.ɵɵtemplate(3, TuiEditLink_ng_container_1_ng_container_3_Template, 2, 0, "ng-container", 4)(4, TuiEditLink_ng_container_1_ng_template_4_Template, 3, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 8)(7, "div", 9);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "tui-input-inline", 10);
    i0.ɵɵlistener("input", function TuiEditLink_ng_container_1_Template_tui_input_inline_input_9_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onChange($event.target == null ? null : $event.target.value));
    })("keydown.backspace", function TuiEditLink_ng_container_1_Template_tui_input_inline_keydown_backspace_9_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onBackspace());
    })("keydown.prevent.enter", function TuiEditLink_ng_container_1_Template_tui_input_inline_keydown_prevent_enter_9_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onSave());
    });
    i0.ɵɵtemplate(10, TuiEditLink_ng_container_1_ng_container_10_Template, 2, 1, "ng-container", 5);
    i0.ɵɵpipe(11, "async");
    i0.ɵɵelementStart(12, "input", 11);
    i0.ɵɵtwoWayListener("ngModelChange", function TuiEditLink_ng_container_1_Template_input_ngModelChange_12_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r2.url, $event) || (ctx_r2.url = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("blur", function TuiEditLink_ng_container_1_Template_input_blur_12_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onBlur(ctx_r2.url));
    });
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(13, "button", 12);
    i0.ɵɵlistener("click", function TuiEditLink_ng_container_1_Template_button_click_13_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onClear());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "button", 13);
    i0.ɵɵlistener("click", function TuiEditLink_ng_container_1_Template_button_click_14_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onSave());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const fullOptions_r5 = i0.ɵɵreference(5);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.anchorMode)("ngIfElse", fullOptions_r5);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r2.prefix);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("t-input_filled", ctx_r2.hasUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(11, 9, ctx_r2.texts$));
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.url);
    i0.ɵɵadvance();
    i0.ɵɵproperty("iconStart", ctx_r2.options.icons.popupLinkRemove);
    i0.ɵɵadvance();
    i0.ɵɵproperty("iconStart", ctx_r2.options.icons.popupLinkSave);
  }
}
function TuiEditLink_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 14);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "tuiShortUrl");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 15);
    i0.ɵɵlistener("click", function TuiEditLink_ng_template_2_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onEdit());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 16);
    i0.ɵɵlistener("click", function TuiEditLink_ng_template_2_Template_button_click_4_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onRemove());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("href", ctx_r2.href, i0.ɵɵsanitizeUrl)("iconStart", ctx_r2.prefixIsHashMode ? ctx_r2.options.icons.hash : ctx_r2.options.icons.externalLink);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 5, ctx_r2.url), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("iconStart", ctx_r2.options.icons.popupPreviewLinkEdit);
    i0.ɵɵadvance();
    i0.ɵɵproperty("iconStart", ctx_r2.options.icons.popupPreviewLinkClear);
  }
}
function TuiEditLink_ng_container_4_button_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 20);
    i0.ɵɵlistener("mousedown", function TuiEditLink_ng_container_4_button_4_Template_button_mousedown_0_listener() {
      const id_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.setAnchor(id_r8));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const id_r8 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" #", id_r8, " ");
  }
}
function TuiEditLink_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "hr", 17);
    i0.ɵɵelementStart(2, "tui-scrollbar")(3, "div", 18);
    i0.ɵɵtemplate(4, TuiEditLink_ng_container_4_button_4_Template, 2, 1, "button", 19);
    i0.ɵɵpipe(5, "tuiFilterAnchors");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(5, 1, ctx_r2.anchorIds, ctx_r2.prefix, ctx_r2.url));
  }
}
let TuiFilterAnchorsPipe = /*#__PURE__*/(() => {
  class TuiFilterAnchorsPipe {
    transform(anchors, prefix, currentUrl) {
      return prefix === '#' ? anchors.filter(anchor => anchor !== currentUrl) : anchors;
    }
    static {
      this.ɵfac = function TuiFilterAnchorsPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiFilterAnchorsPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "tuiFilterAnchors",
        type: TuiFilterAnchorsPipe,
        pure: true
      });
    }
  }
  return TuiFilterAnchorsPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const MAX_LENGTH = 60;
const START = MAX_LENGTH - 20;
const END = MAX_LENGTH - START - 10;
let TuiShortUrlPipe = /*#__PURE__*/(() => {
  class TuiShortUrlPipe {
    transform(url) {
      return url.length < MAX_LENGTH ? url : `${url.slice(0, Math.max(0, START))}...${url.slice(url.length - END)}`;
    }
    static {
      this.ɵfac = function TuiShortUrlPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiShortUrlPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "tuiShortUrl",
        type: TuiShortUrlPipe,
        pure: true
      });
    }
  }
  return TuiShortUrlPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function splitOsiProtocol(rawUrl = '') {
  const [url = '', queryParams = ''] = rawUrl.split(/\?/) ?? [];
  const protocolPosition = url.indexOf(TUI_EDITOR_LINK_OSI_PROTOCOL_DIVIDER) ?? -1;
  const [prefix, path] = protocolPosition > -1 ? [url.slice(0, protocolPosition + TUI_EDITOR_LINK_OSI_PROTOCOL_DIVIDER.length), url.slice(protocolPosition + TUI_EDITOR_LINK_OSI_PROTOCOL_DIVIDER.length, url.length)] : ['', url];
  const pathWithQueries = path + (queryParams.length ? `?${queryParams}` : '');
  const result = [prefix, pathWithQueries].filter(Boolean);
  return path?.includes('://') && result.length > 1 ? splitOsiProtocol(pathWithQueries) : result;
}
function splitSimpleProtocol(rawUrl = '') {
  const [url = '', queryParams = ''] = rawUrl.split(/\?/) ?? [];
  const [prefix, path] = url.split(/:/).slice(-2).filter(Boolean);
  const hardUrl =
  // https://domain.com/path:some:schema:data:test
  url.includes('/') && url.lastIndexOf(':') > url.indexOf('/') || url.includes('?') && url.lastIndexOf(':') > url.indexOf('?');
  return !hardUrl && prefix && path && !isValidUrl(url) ? [`${prefix}:`, path + (queryParams.length ? `?${queryParams}` : '')] : [];
}
function tuiEditLinkParseUrl(url = '') {
  if (url.startsWith(TUI_EDITOR_LINK_HASH_PREFIX)) {
    return {
      prefix: TUI_EDITOR_LINK_HASH_PREFIX,
      path: url.slice(1)
    };
  }
  const [prefix = '', path = ''] = url.includes(TUI_EDITOR_LINK_OSI_PROTOCOL_DIVIDER) ? splitOsiProtocol(url) : splitSimpleProtocol(url);
  if (path.includes(TUI_EDITOR_LINK_SIMPLE_PROTOCOL_DIVIDER)) {
    const [protocol, otherPart] = splitSimpleProtocol(path);
    if (protocol && otherPart) {
      return {
        prefix: protocol,
        path: otherPart
      };
    }
  }
  if (url.startsWith('/') && !url.startsWith('//')) {
    return {
      prefix: url.slice(0, 1),
      path: url.slice(1)
    };
  }
  if (url.startsWith('./')) {
    return {
      prefix: url.slice(0, 2),
      path: url.slice(2)
    };
  }
  return {
    prefix,
    path: prefix === '' ? url : path
  };
}
/**
 * @internal
 */
function isValidUrl(url) {
  return new RegExp(String.raw`^([a-zA-Z]+:\/\/)?` +
  // protocol
  String.raw`((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|localhost|` +
  // domain name
  String.raw`((\d{1,3}\.){3}\d{1,3}))` +
  // OR IP (v4) address
  String.raw`(\:\d+)?(\/[-a-z\d%_.~+\:]*)*` +
  // port and path
  String.raw`(\?[)(;&a-z\d%_.~+=-]*)?` +
  // query string
  String.raw`(\#[-a-z\d_]*)?$`,
  // fragment locator
  'i').test(url);
}
let TuiEditLink = /*#__PURE__*/(() => {
  class TuiEditLink {
    constructor() {
      this.doc = inject(WA_WINDOW)?.document ?? null;
      this.isOnlyAnchorMode = this.detectAnchorMode();
      this.injectionEditor = inject(TuiTiptapEditorService, {
        optional: true
      });
      this.options = inject(TUI_EDITOR_OPTIONS);
      this.url = this.getHrefOrAnchorId();
      this.edit = !this.url;
      this.prefix = this.makeDefaultPrefix();
      this.anchorIds = this.getAllAnchorsIds();
      this.texts$ = inject(TUI_EDITOR_LINK_TEXTS);
      this.inputEditor = null;
      this.addLink = new EventEmitter();
      this.removeLink = new EventEmitter();
    }
    set anchorMode(mode) {
      this.isOnlyAnchorMode = mode;
      this.prefix = mode ? TUI_EDITOR_LINK_HASH_PREFIX : this.makeDefaultPrefix();
    }
    get anchorMode() {
      return this.isOnlyAnchorMode;
    }
    get editor() {
      return this.injectionEditor ?? this.inputEditor;
    }
    get defaultProtocol() {
      return this.options.linkOptions?.protocol ?? TUI_EDITOR_LINK_HTTPS_PREFIX;
    }
    get prefixIsHashMode() {
      return this.prefix === TUI_EDITOR_LINK_HASH_PREFIX;
    }
    get hasUrl() {
      return !!this.url;
    }
    get href() {
      return `${this.prefix}${this.url}`;
    }
    get showAnchorsList() {
      return !this.anchorMode && this.edit && this.anchorIds.length > 0;
    }
    onSelectionChange() {
      if (this.isViewMode) {
        this.url = this.getHrefOrAnchorId();
        this.anchorMode = this.detectAnchorMode();
      }
    }
    onMouseDown(event) {
      if (tuiIsElement(event.target) && !event.target.matches('a, button, input')) {
        event.preventDefault();
      }
    }
    setAnchor(anchor) {
      this.url = anchor;
      this.changePrefix(true);
      this.addLink.emit(this.href);
    }
    changePrefix(useHash) {
      this.prefix = useHash ? TUI_EDITOR_LINK_HASH_PREFIX : this.defaultProtocol;
    }
    onSave() {
      if (this.url) {
        this.addLink.emit(this.href);
      } else {
        this.removeLink.emit();
      }
    }
    onBackspace() {
      if (!this.url) {
        this.prefix = this.isOnlyAnchorMode ? TUI_EDITOR_LINK_HASH_PREFIX : this.defaultProtocol;
      }
    }
    onEdit() {
      this.edit = true;
    }
    onRemove() {
      this.removeLink.emit();
    }
    onChange(url) {
      this.url = this.removePrefix(url);
    }
    onBlur(url) {
      const range = this.editor?.getSelectionSnapshot();
      if (range && !url && !this.url) {
        this.editor?.setTextSelection({
          from: range.anchor,
          to: range.head
        });
        if (this.anchorMode) {
          this.editor?.removeAnchor();
        } else {
          this.editor?.toggleLink('');
        }
      }
    }
    onClear() {
      this.url = '';
    }
    get isViewMode() {
      return !this.edit;
    }
    makeDefaultPrefix() {
      const a = this.getAnchorElement();
      const defaultPrefix = tuiEditLinkParseUrl(a?.getAttribute('href') ?? '').prefix || this.defaultProtocol;
      if (a) {
        if (this.isOnlyAnchorMode) {
          return TUI_EDITOR_LINK_HASH_PREFIX;
        }
        return !a.getAttribute('href') && a.getAttribute('id') || a.getAttribute('href')?.startsWith(TUI_EDITOR_LINK_HASH_PREFIX) ? TUI_EDITOR_LINK_HASH_PREFIX : defaultPrefix;
      }
      return defaultPrefix;
    }
    detectAnchorMode() {
      const a = this.getAnchorElement();
      return !a?.href && (!!a?.getAttribute('id') || a?.getAttribute('data-type') === 'jump-anchor');
    }
    getFocusedParentElement() {
      return this.doc?.getSelection?.()?.focusNode?.parentElement || null;
    }
    getAnchorElement() {
      const focusable = this.getFocusedParentElement();
      return focusable?.closest('a') ?? focusable?.querySelector('img')?.closest('a') ?? null;
    }
    getHrefOrAnchorId() {
      const a = this.getAnchorElement();
      return a ? this.removePrefix(a.getAttribute('href') ?? a.getAttribute('id') ?? '') : this.url;
    }
    removePrefix(url) {
      const fullPath = url.startsWith(TUI_EDITOR_LINK_HASH_PREFIX) || this.prefix === TUI_EDITOR_LINK_HASH_PREFIX || url.startsWith('/') || url.startsWith('./') || url.startsWith('http') || url.startsWith('://') ? url : `${this.prefix ?? ''}${url}`;
      const {
        prefix,
        path
      } = tuiEditLinkParseUrl(fullPath);
      const expectAnchorMode = this.isOnlyAnchorMode || prefix === TUI_EDITOR_LINK_HASH_PREFIX || prefix === '' && this.prefix === TUI_EDITOR_LINK_HASH_PREFIX;
      if (expectAnchorMode) {
        this.prefix = TUI_EDITOR_LINK_HASH_PREFIX;
      } else if (prefix === '') {
        this.prefix = this.defaultProtocol;
      } else {
        this.prefix = prefix;
      }
      return path;
    }
    getAllAnchorsIds() {
      const nodes = Array.from(this.editor?.getOriginTiptapEditor()?.view.dom.querySelectorAll('[data-type="jump-anchor"]') ?? []);
      return Array.from(nodes).map(node => node.getAttribute('id') ?? '').filter(Boolean);
    }
    static {
      this.ɵfac = function TuiEditLink_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiEditLink)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TuiEditLink,
        selectors: [["tui-edit-link"]],
        hostBindings: function TuiEditLink_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("selectionchange", function TuiEditLink_selectionchange_HostBindingHandler() {
              return ctx.onSelectionChange();
            }, false, i0.ɵɵresolveDocument)("mousedown", function TuiEditLink_mousedown_HostBindingHandler($event) {
              return ctx.onMouseDown($event);
            });
          }
        },
        inputs: {
          inputEditor: [0, "editor", "inputEditor"],
          anchorMode: "anchorMode"
        },
        outputs: {
          addLink: "addLink",
          removeLink: "removeLink"
        },
        decls: 5,
        vars: 3,
        consts: [["view", ""], ["fullOptions", ""], ["urlTitle", ""], [1, "t-edit-link"], [4, "ngIf", "ngIfElse"], [4, "ngIf"], [1, "t-label"], [1, "t-label-properties"], [1, "t-url"], [1, "t-prefix"], ["tuiAutoFocus", "", 1, "t-input", 3, "input", "keydown.backspace", "keydown.prevent.enter"], [3, "ngModelChange", "blur", "ngModel"], ["appearance", "icon", "size", "s", "title", "Clear", "tuiIconButton", "", "type", "button", 1, "t-button", 3, "click", "iconStart"], ["appearance", "icon", "size", "s", "title", "Save", "tuiIconButton", "", "type", "button", 1, "t-button", 3, "click", "iconStart"], ["target", "_blank", "tuiLink", "", 1, "t-link", 3, "href", "iconStart"], ["appearance", "icon", "size", "s", "title", "Change link", "tuiIconButton", "", "type", "button", 1, "t-button", "t-edit-button", 3, "click", "iconStart"], ["appearance", "icon", "automation-id", "toolbar__popup-link-clear-button", "size", "s", "title", "Remove link", "tuiIconButton", "", "type", "button", 1, "t-button", 3, "click", "iconStart"], [1, "t-hr"], [1, "t-anchor-list"], ["type", "button", "class", "t-anchor", 3, "mousedown", 4, "ngFor", "ngForOf"], ["type", "button", 1, "t-anchor", 3, "mousedown"]],
        template: function TuiEditLink_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 3);
            i0.ɵɵtemplate(1, TuiEditLink_ng_container_1_Template, 15, 11, "ng-container", 4)(2, TuiEditLink_ng_template_2_Template, 5, 7, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, TuiEditLink_ng_container_4_Template, 6, 5, "ng-container", 5);
          }
          if (rf & 2) {
            const view_r9 = i0.ɵɵreference(3);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.edit)("ngIfElse", view_r9);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.showAnchorsList);
          }
        },
        dependencies: [AsyncPipe, FormsModule, i1.DefaultValueAccessor, i1.NgControlStatus, i1.NgModel, NgForOf, NgIf, TuiAutoFocus, TuiButton, TuiFilterAnchorsPipe, TuiInputInline, TuiLink, TuiScrollbar, TuiShortUrlPipe],
        styles: ["[_nghost-%COMP%]{display:block;min-inline-size:18.75rem}.t-edit-link[_ngcontent-%COMP%]{display:flex;min-block-size:4rem;align-items:center;padding-right:.75rem}.t-label[_ngcontent-%COMP%]{font:var(--tui-font-text-s);block-size:var(--tui-height-l);box-sizing:border-box;padding:.4375rem 1rem;min-inline-size:12.5rem;max-inline-size:25rem;inline-size:100%}.t-label-properties[_ngcontent-%COMP%]{display:flex;align-items:center;max-inline-size:8.375rem;justify-content:space-between}.t-property_inactive[_ngcontent-%COMP%]{opacity:.5}.t-url[_ngcontent-%COMP%]{display:flex;font:var(--tui-font-text-m);color:var(--tui-text-secondary)}.t-input[_ngcontent-%COMP%]{flex:1}.t-input_filled[_ngcontent-%COMP%]{color:var(--tui-text-primary)}.t-button[_ngcontent-%COMP%]{inline-size:2rem;block-size:2rem;margin:0 .25rem;transition:background .2s}.t-edit-button[_ngcontent-%COMP%]{margin-left:auto}.t-link[_ngcontent-%COMP%]{margin:0 1rem;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.t-cleaner[_ngcontent-%COMP%]{transition-property:color;transition-duration:var(--tui-duration, .3s);transition-timing-function:ease-in-out;color:var(--tui-text-secondary);cursor:pointer;margin-left:auto}.t-cleaner[_ngcontent-%COMP%]:hover{color:var(--tui-background-accent-opposite-pressed)}.t-cleaner_hidden[_ngcontent-%COMP%]{visibility:hidden}.t-anchor-list[_ngcontent-%COMP%]{display:flex;max-block-size:12.5rem;flex-direction:column}.t-anchor[_ngcontent-%COMP%]{-webkit-appearance:none;appearance:none;border:0;background:none;font-size:inherit;line-height:inherit;text-decoration:none;min-block-size:2.75rem;padding:.375rem .5rem;margin:.125rem .5rem;border-radius:var(--tui-radius-m);text-align:start}.t-anchor[_ngcontent-%COMP%]:hover{background:var(--tui-background-base-alt);cursor:pointer}"],
        changeDetection: 0
      });
    }
  }
  return TuiEditLink;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiEditLink, TuiFilterAnchorsPipe, TuiShortUrlPipe, tuiEditLinkParseUrl };
